import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"
import _imports_0 from './../assets/circle.svg'


const _hoisted_1 = { class: "w-full h-full relative" }
const _hoisted_2 = {
  key: 0,
  class: "overflow-hidden h-full w-full md:flex md:justify-center md:items-center absolute z-10"
}
const _hoisted_3 = { class: "w-full aspect-box relative" }

import { ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'loader',
  props: {
    isPageLoaded: {
        type: Boolean,
        required: true,
    },
},
  setup(__props) {

const loading = ref(true);
const isAnimating = ref(false);
const showElement = ref(false);

const props = __props;

async function Load() {
    loading.value = true;
    showElement.value = true;

    //await new Promise(r => setTimeout(r, 5000)); // fake load

    isAnimating.value = true;
    await new Promise((r) => setTimeout(r, 400));

    isAnimating.value = false;

    loading.value = false;
}

function reset() {
    loading.value = true;
    isAnimating.value = false;
    showElement.value = false;
}

watch(
    () => props.isPageLoaded,
    (newValue, oldValue) => {
        if (newValue == true) {
            Load();
        } else reset();
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              ref: "loader",
              class: _normalizeClass(["relative h-full w-full", {
                        'animate-[grow_0.5s_ease-in-out_infinite]': isAnimating.value,
                        'animate-[breathe_1s_linear_infinite]': !isAnimating.value,
                    }])
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1)
            ]))], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["h-full w-full top-0 absolute z-0", {
                'animate-[fadeIn_2s_ease-in-out]': loading.value,
                hidden: !showElement.value,
            }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})